import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import Spinner from '../Components/Spinner';
import { getApiBase } from '../utils/authClient';
import { useLocale } from '../context/LocaleContext';

const toastOptions = {
  position: 'top-right',
  autoClose: 8000,
  pauseOnHover: true,
  draggable: true,
  theme: 'dark',
};

export default function ForgotPassword() {
  const { t } = useLocale();
  const apiBase = getApiBase();
  const [email, setEmail] = useState('');
  const [loader, setLoader] = useState('none');
  const [sent, setSent] = useState(false);
  const [devResetUrl, setDevResetUrl] = useState('');
  const [emailSent, setEmailSent] = useState(null);
  const [smtpConfigured, setSmtpConfigured] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error(t('auth.forgotEmailRequired'), toastOptions);
      return;
    }

    setLoader('flex');
    try {
      const res = await fetch(`${apiBase}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed }),
      });
      const data = await res.json().catch(() => ({}));
      setLoader('none');

      if (!res.ok || data.status === false) {
        toast.error(data.message || t('auth.forgotSendFail'), toastOptions);
        return;
      }

      setSent(true);
      setEmailSent(Boolean(data.emailSent));
      setSmtpConfigured(Boolean(data.smtpConfigured));
      if (data.devResetUrl) setDevResetUrl(data.devResetUrl);
      if (data.emailSent) {
        toast.success(data.message, toastOptions);
      } else {
        toast.warn(data.message, { ...toastOptions, autoClose: 12000 });
      }
    } catch {
      setLoader('none');
      toast.error(t('auth.serverConnect'), toastOptions);
    }
  };

  return (
    <div className="login_split_page login_auth_simple">
      <main className="login_auth_simple_main">
        <aside className="login_split_panel login_auth_panel_only">
          <div className="login_split_panel_inner">
            <Link to="/login_user" className="login_auth_back">
              <i className="fa fa-arrow-left" aria-hidden="true" /> {t('auth.backToSignIn')}
            </Link>

            <h2 className="login_split_panel_title">{t('auth.forgotTitle')}</h2>
            <p className="login_split_panel_subtitle">{t('auth.forgotSubtitle')}</p>

            {sent ? (
              <div className="login_auth_success" role="status">
                {emailSent ? (
                  <p>{t('auth.forgotSentOk')}</p>
                ) : smtpConfigured === false ? (
                  <div className="login_auth_notice login_auth_notice--warn">
                    <p>
                      <strong>{t('auth.forgotSmtpWarnTitle')}</strong> {t('auth.forgotSmtpWarnBody')}
                    </p>
                    <p>{t('auth.forgotSmtpHint')}</p>
                  </div>
                ) : (
                  <p>{t('auth.forgotSentMaybe')}</p>
                )}
                {devResetUrl ? (
                  <div className="login_auth_dev_box">
                    <p className="login_auth_dev_title">{t('auth.forgotDevTitle')}</p>
                    <a href={devResetUrl} className="login_form_button login_auth_success_btn">
                      {t('auth.forgotDevBtn')}
                    </a>
                    <p className="login_auth_dev_link">{devResetUrl}</p>
                  </div>
                ) : null}
                <Link to="/login_user" className="login_form_button login_auth_success_btn">
                  {t('auth.forgotGoSignIn')}
                </Link>
              </div>
            ) : (
              <form className="login_u_form" onSubmit={handleSubmit} noValidate>
                <div className="login_field">
                  <label htmlFor="forgot-email">{t('auth.email')}</label>
                  <input
                    id="forgot-email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    placeholder={t('auth.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <button className="login_form_button" type="submit">
                  {t('auth.forgotSubmit')}
                  <Spinner id="forgot_loader" style={loader} />
                </button>
              </form>
            )}
          </div>
        </aside>
      </main>
      <ToastContainer />
    </div>
  );
}
